/* This file is generated by scripts/i18n/generate-catalog-wiring.mjs. */
import type { Messages } from '@lingui/core';
import { messages as catalog0 } from '../../i18n/locales/en/messages';
import { messages as catalog1 } from '../../i18n/locales/es/messages';

export const GENERATED_CATALOG_LOCALES = [
    'en',
    'es',
] as const;

const generatedCatalogs: Readonly<Record<string, Messages>> = {
    'en': catalog0,
    'es': catalog1,
};

export function getGeneratedCatalog(locale: string): Messages | undefined {
    return generatedCatalogs[locale];
}
